export default __webpack_public_path__ + "static/media/purple-certificate-check-badge.40611a73.svg";